var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6262 20.2698C5.56784 20.2698 0.110596 17.097 0.110596 10.1349C0.110596 3.17282 5.56784 0 10.6262 0C13.4364 0 16.0291 0.92465 17.9509 2.61078C20.0359 4.46008 21.1419 7.07086 21.1419 10.1349C21.1419 13.1989 20.0359 15.7916 17.9509 17.6409C16.0291 19.327 13.4183 20.2698 10.6262 20.2698Z",
    fill: "url(#paint0_radial_305_7959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3088 4.11016C20.2752 5.66937 20.7792 7.52593 20.7792 9.59098C20.7792 12.655 19.6732 15.2477 17.5882 17.097C15.6664 18.7831 13.0556 19.7259 10.2635 19.7259C6.9892 19.7259 3.5553 18.3933 1.52832 15.5668C3.47915 18.7686 7.14874 20.2698 10.6262 20.2698C13.4182 20.2698 16.029 19.327 17.9508 17.6409C20.0358 15.7916 21.1418 13.1989 21.1418 10.1349C21.1418 7.82508 20.5127 5.77272 19.3088 4.11016Z",
    fill: "#EB8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6262 20.2698C5.56784 20.2698 0.110596 17.097 0.110596 10.1349C0.110596 3.17282 5.56784 0 10.6262 0C13.4364 0 16.0291 0.92465 17.9509 2.61078C20.0359 4.46008 21.1419 7.07086 21.1419 10.1349C21.1419 13.1989 20.0359 15.7916 17.9509 17.6409C16.0291 19.327 13.4183 20.2698 10.6262 20.2698Z",
    fill: "url(#paint1_linear_305_7959)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6262 20.2698C5.56784 20.2698 0.110596 17.097 0.110596 10.1349C0.110596 3.17282 5.56784 0 10.6262 0C13.4364 0 16.0291 0.92465 17.9509 2.61078C20.0359 4.46008 21.1419 7.07086 21.1419 10.1349C21.1419 13.1989 20.0359 15.7916 17.9509 17.6409C16.0291 19.327 13.4183 20.2698 10.6262 20.2698Z",
    fill: "url(#paint2_linear_305_7959)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3088 4.11016C20.2752 5.66937 20.7792 7.52593 20.7792 9.59098C20.7792 12.655 19.6732 15.2477 17.5882 17.097C15.6664 18.7831 13.0556 19.7259 10.2635 19.7259C6.9892 19.7259 3.5553 18.3933 1.52832 15.5668C3.47915 18.7686 7.14874 20.2698 10.6262 20.2698C13.4182 20.2698 16.029 19.327 17.9508 17.6409C20.0358 15.7916 21.1418 13.1989 21.1418 10.1349C21.1418 7.82508 20.5127 5.77272 19.3088 4.11016Z",
    fill: "#EB8F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6989 18.6254C9.60749 18.6181 8.72454 17.7352 8.71729 16.6437V14.3593C8.71729 13.2642 9.60386 12.3776 10.6989 12.3776C11.794 12.3776 12.6806 13.2642 12.6806 14.3593V16.6455C12.6733 17.737 11.7904 18.6181 10.6989 18.6254Z",
    fill: "#422B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94375 6.31301C7.31361 6.31301 7.67622 6.41998 7.98806 6.61941C9.01061 7.26667 9.43849 8.79506 8.61356 10.3742C8.04427 11.462 7.18851 11.9643 6.37808 11.9643C6.00822 11.9643 5.64561 11.8573 5.33377 11.6578C4.31122 11.0106 3.88334 9.4822 4.70827 7.90304C5.27757 6.81522 6.13151 6.31301 6.94375 6.31301Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M20.6594 11.9661C20.411 11.7848 20.4418 11.5835 19.7528 11.8609C19.4682 11.9769 19.1418 12.6296 19.1418 12.6296C19.1418 12.6296 18.6505 11.647 17.6787 12.9542C15.9128 15.3256 15.1405 15.2168 14.1016 16.3047C13.4326 17.0009 12.8542 17.6644 13.0772 18.9825C13.2023 19.7186 13.5522 19.9199 13.5522 19.9199C13.5522 19.9199 13.7662 19.9199 15.8657 18.832C17.9652 17.7442 19.7982 16.2049 20.8062 13.7392",
    fill: "url(#paint3_linear_305_7959)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0028 16.7742C15.7915 16.1759 16.5529 15.6266 16.9119 15.1534C17.2709 14.6802 17.6571 13.6884 17.8892 13.0394C18.1212 12.3903 18.7957 12.073 19.1583 12.6278C19.2526 12.7765 19.1782 13.353 19.1583 13.5742C19.3559 13.2461 19.4955 12.8853 19.5717 12.51C19.753 11.6252 20.6776 11.3387 20.8408 12.5281C20.8408 12.5281 21.5279 12.5553 21.2233 14.6874C21.071 15.5178 20.7973 16.3228 20.4075 17.0716C19.4302 18.9136 18.6651 19.7676 17.6752 20.4456C16.1269 21.5045 14.6601 21.2524 14.2014 20.6505C13.4182 19.6153 13.6285 17.8167 15.0028 16.7742Z",
    fill: "url(#paint4_radial_305_7959)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.151 12.6278C19.151 12.9814 18.8102 14.2124 18.6815 14.5279C18.2373 15.6973 17.4268 16.2412 17.6535 16.4261C17.8801 16.6111 18.3134 16.2176 18.9389 14.7328C19.1311 14.2269 19.2435 13.6957 19.2689 13.1554C19.2671 12.9723 19.2272 12.7928 19.151 12.6278Z",
    fill: "#ED6C30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3442 11.7322C20.5744 11.8319 20.9171 12.4882 20.404 14.3266C20.0867 15.7154 19.0315 16.796 19.2854 16.9175C19.5845 17.1187 20.268 15.9856 20.7521 14.4155C20.879 13.9405 20.9588 13.4546 20.986 12.965C20.9933 12.7185 20.9099 11.7993 20.3442 11.7322Z",
    fill: "#ED6C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M0.641485 11.9661C0.889872 11.7848 0.85905 11.5835 1.548 11.8609C1.83265 11.9769 2.159 12.6296 2.159 12.6296C2.159 12.6296 2.65033 11.647 3.62212 12.9542C5.38802 15.3256 6.16038 15.2168 7.19925 16.3047C7.86645 17.0009 8.44481 17.6644 8.2218 18.9825C8.09852 19.7186 7.7486 19.9199 7.7486 19.9199C7.7486 19.9199 7.4005 19.9199 5.73069 19.0677C5.58746 18.9952 5.60015 18.9209 5.43516 18.8339C3.33566 17.746 1.50268 16.2068 0.494629 13.741",
    fill: "url(#paint5_linear_305_7959)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29842 16.7742C5.50974 16.1759 4.74827 15.6266 4.38929 15.1534C4.0303 14.6802 3.64413 13.6884 3.41024 13.0394C3.17636 12.3903 2.50373 12.073 2.15018 12.6278C2.0559 12.7765 2.13024 13.353 2.15018 13.5742C1.95075 13.2461 1.80752 12.8853 1.72956 12.51C1.54825 11.6252 0.623603 11.3387 0.460429 12.5281C0.460429 12.5281 -0.226713 12.5553 0.0778779 14.6874C0.230173 15.5178 0.503942 16.3228 0.893746 17.0716C1.86916 18.9136 2.63608 19.7676 3.626 20.4456C5.17252 21.5045 6.63927 21.2524 7.09978 20.6505C7.87757 19.6153 7.6727 17.8167 6.29842 16.7742Z",
    fill: "url(#paint6_radial_305_7959)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15032 12.6278C2.15032 12.9814 2.49117 14.2124 2.6199 14.5279C3.06409 15.6973 3.87271 16.2412 3.64789 16.4261C3.42307 16.6111 2.98613 16.2176 2.36063 14.7328C2.16845 14.2269 2.05785 13.6957 2.03247 13.1554C2.03247 12.9723 2.07236 12.7928 2.15032 12.6278Z",
    fill: "#ED6C30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.955357 11.7322C0.726914 11.8319 0.38425 12.4882 0.89734 14.323C1.21462 15.7118 2.26981 16.7924 2.01599 16.9138C1.71683 17.1151 1.03332 15.9819 0.549237 14.4119C0.422324 13.9368 0.34255 13.4509 0.315354 12.9614C0.308102 12.7185 0.391502 11.7993 0.955357 11.7322Z",
    fill: "#ED6C30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6372 10.3869C8.50304 10.8601 8.25465 11.2916 7.91199 11.6451C7.54213 12.0277 7.05442 12.2743 6.52864 12.3468C5.96478 12.4175 5.39367 12.2706 4.93316 11.9389C4.4799 11.6089 4.13905 11.1447 3.95956 10.6135C3.91786 10.4848 3.88341 10.3525 3.85803 10.2183C3.83446 10.0859 3.81814 9.95177 3.80908 9.81761L3.79639 9.60911L3.80545 9.40967C3.81089 9.27732 3.8254 9.14678 3.85078 9.01624C3.95049 8.51584 4.14812 8.03901 4.43095 7.61476C4.70472 7.18145 5.07821 6.82065 5.51877 6.55957C5.94846 6.30031 6.45793 6.20603 6.95289 6.29306V6.34563C6.49419 6.3547 6.04818 6.51062 5.68376 6.78983C5.32115 7.06722 5.022 7.42077 4.80625 7.82326C4.57962 8.2185 4.42732 8.65001 4.35299 9.09964C4.28409 9.54927 4.32217 10.008 4.4654 10.4395C4.60319 10.871 4.86971 11.2517 5.2305 11.5273C5.5913 11.8083 6.04274 11.9479 6.49963 11.9189C6.95289 11.8863 7.38621 11.7122 7.73612 11.4221C8.08966 11.1302 8.37975 10.7713 8.59006 10.3633L8.6372 10.3869Z",
    fill: "#EB8F00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4717 6.31301C15.2839 6.31301 16.1379 6.82066 16.7072 7.90304C17.5357 9.47495 17.1042 11.0106 16.0817 11.6578C15.7698 11.8591 15.4072 11.9661 15.0374 11.9661C14.2269 11.9661 13.3712 11.4584 12.8019 10.376C11.9679 8.80231 12.4048 7.26667 13.4274 6.61941C13.7392 6.41998 14.1018 6.31301 14.4717 6.31301Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4716 6.28581C14.9666 6.19878 15.4761 6.29306 15.9057 6.55233C16.3463 6.8134 16.7198 7.1742 16.9936 7.60751C17.2782 8.0372 17.4758 8.51766 17.5737 9.0235C17.5973 9.15404 17.6136 9.28458 17.6191 9.41693V9.61636V9.81761C17.6082 10.0878 17.5574 10.3561 17.4704 10.6135C17.2909 11.1448 16.9519 11.6071 16.4968 11.9371C16.0363 12.2707 15.467 12.4157 14.9031 12.345C14.3719 12.2743 13.8806 12.0277 13.5089 11.6433C13.1662 11.2916 12.916 10.8601 12.7837 10.3869L12.8308 10.3615C13.0393 10.7676 13.3276 11.1284 13.6793 11.4221C14.0311 11.714 14.4644 11.8881 14.9195 11.9207C15.3763 11.9497 15.8278 11.8101 16.1886 11.5291C16.5476 11.2517 16.8141 10.8728 16.9519 10.4413C17.0951 10.0098 17.1332 9.55109 17.0643 9.10146C16.9936 8.65183 16.8431 8.2167 16.6183 7.81964C16.4025 7.41715 16.1034 7.0636 15.7408 6.78621C15.3763 6.507 14.9303 6.35108 14.4716 6.34201V6.28581Z",
    fill: "#EB8F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_305_7959",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6262 10.1349) scale(10.327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_7959",
    x1: 10.6262,
    y1: 20.2698,
    x2: 10.6262,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#40C0E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_7959",
    x1: 10.6262,
    y1: 20.2698,
    x2: 10.6262,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F4A223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FDE030",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_7959",
    x1: 16.9174,
    y1: 21.9051,
    x2: 16.9174,
    y2: 12.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6C30",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_305_7959",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6846 15.8246) rotate(141.52) scale(8.10396 7.4689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_7959",
    x1: 4.38255,
    y1: 21.9051,
    x2: 4.38255,
    y2: 12.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6C30",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_305_7959",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.60751 15.8109) rotate(38.4802) scale(8.10396 7.4689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji4);
export default __webpack_public_path__ + "static/media/emoji_4.3bab6588aebdc3a57110b43912b72a99.svg";
export { ForwardRef as ReactComponent };